<ion-header>
  <ion-toolbar class="sticky-toolbar">
    <div class="toolbar-container">
      <div class="flexed header-container">
        <ion-buttons slot="start">
          <ion-button (click)="navigateBack()">
            <ion-icon name="chevron-back-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
        <app-article-location-display
          [collectionId]="collectionId"
          (moveRequested)="showCollectionSelector($event)"
          [disabled]="isGeneratingArticle || isLoading"
        ></app-article-location-display>
      </div>
      <ion-buttons slot="end">
        <ion-button
          [hidden]="!articleId"
          (click)="showArticleActions($event)"
          [disabled]="isLoading || isGeneratingArticle"
          class="nav-button"
          color="dark"
          fill="clear"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'bottom',
            content: 'Show article options'
          }"
        >
          <ion-icon name="ellipsis-horizontal"></ion-icon>
        </ion-button>

        <!-- Show Accept/Reject buttons when there are outstanding diffs -->
        <ng-container *ngIf="hasOutstandingDiffs">
          <ion-button
            (click)="rejectAllChanges()"
            [disabled]="isLoading || isGeneratingArticle"
            fill="outline"
            color="medium"
            style="margin: 0 4px"
            ngxTippy
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Reject all AI-generated changes'
            }"
          >
            <ion-icon name="close-outline" slot="start"></ion-icon>
            <span>Reject All</span>
          </ion-button>
          <ion-button
            (click)="acceptAllChanges()"
            [disabled]="isLoading || isGeneratingArticle"
            class="button-dark-border"
            style="margin: 0 8px"
            ngxTippy
            [tippyProps]="{
              touch: false,
              arrow: false,
              placement: 'bottom',
              content: 'Accept all AI-generated changes'
            }"
          >
            <ion-icon name="checkmark-outline" slot="start"></ion-icon>
            <span>Accept All</span>
          </ion-button>
        </ng-container>

        <!-- Show Save button when there are no outstanding diffs -->
        <ion-button
          *ngIf="!hasOutstandingDiffs"
          (click)="saveArticle()"
          [disabled]="isLoading || !title"
          class="button-dark-border"
          style="margin: 0 8px"
          ngxTippy
          [tippyProps]="{
            touch: false,
            arrow: false,
            placement: 'bottom',
            content: 'Save article'
          }"
        >
          <ion-spinner *ngIf="isLoading" name="crescent"></ion-spinner>
          <span *ngIf="!isLoading">Save</span>
        </ion-button>
      </ion-buttons>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content>
  <ion-grid fixed="true">
    <ion-row>
      <!-- Main Content Column -->
      <ion-col size="12" size-md="8">
        <ion-textarea
          #titleInput
          placeholder="e.g. How to configure SSO"
          [(ngModel)]="title"
          class="input-field title-input"
          (keydown)="handleTitleKeydown($event)"
          [disabled]="isGeneratingArticle || isLoading"
          autoGrow="true"
        ></ion-textarea>

        <div class="tiptap-editor-container">
          <ion-skeleton-text
            *ngIf="isGeneratingArticle"
            class="linear-gradient-subtle-animated"
            style="
              width: 90%;
              height: 14px;
              margin-bottom: 4px;
              margin-left: 28px;
            "
          ></ion-skeleton-text>
          <ion-skeleton-text
            *ngIf="isGeneratingArticle"
            class="linear-gradient-subtle-animated"
            style="
              width: 80%;
              height: 14px;
              margin-bottom: 4px;
              margin-left: 28px;
            "
          ></ion-skeleton-text>
          <ion-skeleton-text
            *ngIf="isGeneratingArticle"
            class="linear-gradient-subtle-animated"
            style="
              width: 85%;
              height: 14px;
              margin-bottom: 4px;
              margin-left: 28px;
            "
          ></ion-skeleton-text>
          <ion-skeleton-text
            *ngIf="isGeneratingArticle"
            class="linear-gradient-subtle-animated"
            style="
              width: 45%;
              height: 14px;
              margin-bottom: 4px;
              margin-left: 28px;
            "
          ></ion-skeleton-text>

          <app-knowledge-base-editor
            #editorContainer
            [initialContent]=""
            (focusTitle)="onFocusTitleRequested()"
            (outstandingDiffsChange)="onOutstandingDiffsChange($event)"
            [editable]="!isLoading && !isGeneratingArticle"
            [diffMode]="diffModeEnabled"
            [comparisonContent]="comparisonContent"
            [trackChangesEnabled]="trackChangesEnabled"
            [suggestionsMode]="suggestionsMode"
            [class.disabled]="isGeneratingArticle"
          ></app-knowledge-base-editor>
        </div>
      </ion-col>

      <!-- Right Sidebar Column -->
      <ion-col size="12" size-md="4">
        <ion-card class="sidebar-card">
          <ion-card-content>
            <!-- Status -->
            <ion-label class="input-label">Status</ion-label>
            <ion-select
              interface="popover"
              class="select-outline"
              [(ngModel)]="status"
              style="width: 100%; padding: 10px; margin-bottom: 10px"
              placeholder="Select Status"
              [disabled]="isGeneratingArticle || isLoading"
            >
              <ion-select-option value="active">Active</ion-select-option>
              <ion-select-option value="inactive">Inactive</ion-select-option>
            </ion-select>

            <!-- Link -->
            <ion-label class="input-label">Source Link</ion-label>
            <ion-input
              placeholder="https://example.com (Optional)"
              [(ngModel)]="url"
              class="input-field link-input"
              type="url"
              [disabled]="isGeneratingArticle || isLoading"
            ></ion-input>

            <!-- Visibility Section -->
            <ion-label class="input-label">Visibility</ion-label>
            <div class="user-groups-container">
              <ion-chip
                *ngIf="!userGroups?.length"
                color="success"
                class="chip"
                style="height: 20px; padding: 6px"
                mode="ios"
              >
                <ion-label>Public</ion-label>
              </ion-chip>
              <ion-chip
                *ngFor="let group of userGroups; trackBy: trackByUserGroupId"
                mode="ios"
                color="dark"
                class="chip tag-chip"
              >
                <ion-label
                  (click)="
                    !isLoading &&
                      !isGeneratingArticle &&
                      removeUserGroup(group.id!)
                  "
                  >{{ group.name }}</ion-label
                >
              </ion-chip>
              <ion-chip
                mode="ios"
                color="dark"
                class="chip tag-chip tag-chip-light"
                (click)="addUserGroup($event)"
                style="background: transparent"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Restrict document access to certain user groups'
                }"
              >
                <ion-label>
                  <ion-icon name="lock-closed-outline"></ion-icon
                  ><ion-icon
                    name="add-outline"
                    style="margin-left: -3px"
                  ></ion-icon>
                </ion-label>
              </ion-chip>
            </div>
            <ion-label class="input-label">Channels</ion-label>
            <div class="user-groups-container">
              <ion-chip
                *ngIf="!channels?.length"
                color="success"
                class="chip"
                style="height: 20px; padding: 6px"
                mode="ios"
              >
                <ion-label>All channels</ion-label>
              </ion-chip>
              <ion-chip
                *ngFor="let channel of channels; trackBy: trackByChannelId"
                mode="ios"
                color="dark"
                class="chip tag-chip"
              >
                <ion-label
                  (click)="
                    !isLoading &&
                      !isGeneratingArticle &&
                      removeChannel(channel.id)
                  "
                >
                  {{ channel.name }}
                </ion-label>
              </ion-chip>
              <ion-chip
                mode="ios"
                color="dark"
                class="chip tag-chip tag-chip-light"
                (click)="addChannel($event)"
                style="background: transparent"
                ngxTippy
                [tippyProps]="{
                  touch: false,
                  arrow: false,
                  placement: 'bottom',
                  content: 'Restrict document access to certain channels'
                }"
              >
                <ion-label>
                  <ion-icon name="chatbubble-outline"></ion-icon
                  ><ion-icon
                    name="add-outline"
                    style="margin-left: -3px"
                  ></ion-icon>
                </ion-label>
              </ion-chip>
            </div>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>
